import { fetchUserPreferences } from "../pages/tatvaShots/service";
import useStore from "../store/useStore";

const useUserPreferences = () => {
  const { setTatvaShots } = useStore();

  const getUserPreferences = async () => {
    try {
      const preferences = await fetchUserPreferences();
      setTatvaShots({ userPreferences: preferences });
      return preferences;
    } catch (err) {
      // Handle error
    }
  };

  return { getUserPreferences };
};

export default useUserPreferences;
